import { FC } from "react";
import { useTranslations } from "@jugl-web/utils";
import { InteractiveContainer } from "@jugl-web/ui-components";
import { tokenizeMessageBody } from "@web-src/modules/chats/utils";
import {
  ChatMessagePayloadAttachment,
  ChatMessagePayloadConference,
} from "@jugl-web/rest-api";
import { ReactComponent as CrossIcon } from "./assets/cross.svg";
import { ReactComponent as ReplyIcon } from "./assets/reply-icon.svg";
import { MessageTokensDisplay } from "../../../MessageTokensDisplay";
import { AttachmentPreview } from "../../../AttachmentPreview";
import { VideoMeetingAttachment } from "../../../VideoMeetingAttachment";

export type ChatInputActionInfoProps = {
  type: "reply" | "edit";
  text: string;
  attachment?: ChatMessagePayloadAttachment;
  preview?: string;
  title?: string;
  conference?: ChatMessagePayloadConference;
  onClose?: () => void;
};

export const ChatInputActionInfo: FC<ChatInputActionInfoProps> = ({
  type,
  text,
  title,
  attachment,
  preview,
  conference,
  onClose,
}) => {
  const { t } = useTranslations();

  return (
    <div className="mb-4">
      <div className="flex items-center gap-2 overflow-hidden">
        {type === "reply" && (
          <div className="relative top-[2px] shrink-0">
            <ReplyIcon className="fill-primary-500" />
          </div>
        )}
        {attachment && (
          <AttachmentPreview
            attachment={attachment}
            color="primary"
            preview={preview}
          />
        )}
        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <div className="font-secondary flex items-center gap-2">
            <span className="text-primary-500 text-sm font-medium">
              {type === "reply" ? (
                <>
                  {t({
                    id: "chats-page.reply-to",
                    defaultMessage: "Reply to",
                  })}{" "}
                  <span className="text-black">{title}</span>
                </>
              ) : (
                <>
                  {t({
                    id: "chats-page.edit",
                    defaultMessage: "Edit",
                  })}
                </>
              )}
            </span>
          </div>
          {conference ? (
            <VideoMeetingAttachment
              conference={conference}
              isPreview
              isTile
              tileText={text}
            />
          ) : (
            <span
              className="font-secondary text-grey-800 block min-w-0 overflow-hidden text-ellipsis whitespace-nowrap text-sm"
              style={{ flex: "1 1 auto" }}
            >
              <MessageTokensDisplay tokens={tokenizeMessageBody(text)} />
            </span>
          )}
        </div>
        <InteractiveContainer onClick={onClose}>
          <CrossIcon />
        </InteractiveContainer>
      </div>
    </div>
  );
};
